module.exports = __webpack_public_path__ + "img/52114142_L.03842be8.png";